webpackJsonp([11],{

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//

exports.default = (0, _reactStatic.withSiteData)(function (_React$Component) {
    _inherits(Redirect, _React$Component);

    function Redirect(props) {
        _classCallCheck(this, Redirect);

        return _possibleConstructorReturn(this, (Redirect.__proto__ || Object.getPrototypeOf(Redirect)).call(this, props));
    }

    _createClass(Redirect, [{
        key: 'render',
        value: function render() {

            if (typeof document !== 'undefined') {
                return _react2.default.createElement(
                    'div',
                    { className: 'mT' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Redirecting...'
                    ),
                    window.location.replace(this.props.redirectURL)
                );
            } else {
                return null;
            }
        }
    }]);

    return Redirect;
}(_react2.default.Component));

/***/ })

});


// WEBPACK FOOTER //
// templates/src/pages/Redirect.c91c5a7a.js